// @ts-nocheck

import React, { useCallback } from 'react';
import styled from 'styled-components';

import { type ExternalLinkOptions } from '../../actions';
import { RedirectServices, getRedirectUrl } from '../../config/urls';
import { ModalContentSpacing, ModalFormat } from '../../constants/ui/modal';
import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';
import { Modal as ModalTheme } from '../../styled-components/dark/modal';
import {
  UserNotificationButton,
  UserNotificationCloseButton,
  UserNotificationContent,
  UserNotificationCtaWrapper,
} from '../../styled-components/shared';
import fetch from '../../utils/fetch';
import Modal from '../Modal';

const InnerWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

type UserActionButtonProps = {
  action: unknown;
  onLinkOpen: (url: string, options?: ExternalLinkOptions) => void;
  ack: () => void;
};

const UserActionButton = ({ action, onLinkOpen, ack }: UserActionButtonProps) => {
  const { label } = action;

  const onClick = useCallback(() => {
    if (action.type === 'link') {
      const url = getRedirectUrl(RedirectServices.ENCODED_URL, { url: action.action });
      onLinkOpen(url, { auth: true });
    } else if (action.type === 'xhr') {
      fetch(action.action, { method: 'GET', credentials: 'same-origin' });
      ack();
    }
  }, [ack, action, onLinkOpen]);

  return (
    <UserNotificationButton key={label} onClick={onClick}>
      {label}
    </UserNotificationButton>
  );
};

const MessageTitle = styled.div`
  font-weight: bold;
  font-size: 120%;
  border-bottom: 2px solid red;
  margin-bottom: 0.5em;
`;

const MessageLabel = styled.div`
  max-height: 100%;
  overflow: auto;
`;

type UserNotificationMessageProps = {
  ack: () => void;
  message: {
    title?: unknown;
    text?: unknown;
    actions: unknown;
    dismissable?: boolean;
  };
  onLinkOpen: (url: string, options?: ExternalLinkOptions) => void;
};

const UserNotificationMessage = ({
  ack,
  message: { title, text, actions, dismissable },
  onLinkOpen,
}: UserNotificationMessageProps) => {
  const hasActionMessages = actions?.length > 0;
  const hasOnlyDismissableButton = dismissable && !hasActionMessages;

  return (
    <Modal
      backgroundColor={ModalTheme.backgroundColor.cgu}
      closeOnEsc={hasOnlyDismissableButton}
      closeOnOutsideClick={hasOnlyDismissableButton}
      format={ModalFormat.SMALL}
      hasBorderRadius
      hasCloseButton={hasOnlyDismissableButton}
      hasOverlay
      onClose={ack}
      zIndex={theme.ZIndices.navBar}
      blockHeight
      contentSpacing={ModalContentSpacing.SMALL}
    >
      <InnerWrapper>
        <UserNotificationContent>
          {title ? (
            <MessageTitle
              dangerouslySetInnerHTML={{
                __html: title,
              }}
            />
          ) : null}
          {text ? <MessageLabel dangerouslySetInnerHTML={{ __html: text }} /> : null}
        </UserNotificationContent>
        <UserNotificationCtaWrapper>
          {dismissable ? <UserNotificationCloseButton onClick={ack}>{__('Close')}</UserNotificationCloseButton> : null}
          {hasActionMessages
            ? actions.map((action, i) => (
                <UserActionButton key={`user-notif-msg-${i}`} ack={ack} action={action} onLinkOpen={onLinkOpen} />
              ))
            : null}
        </UserNotificationCtaWrapper>
      </InnerWrapper>
    </Modal>
  );
};

export default UserNotificationMessage;
